import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import SidePanel from "./SidePanel/SidePanel";
import NGLContext from '../NGLContext'
import NGLSpeedDials from "./NGLSpeedDials";
import ToggleBar from './ToggleBar/ToggleBar'


export const viewHeight = 625;
const styles = theme => ({
    contentWrapper: {
        height: viewHeight,
        touchAction: 'none',
        position: 'relative',
    },
});


@withStyles(styles)
class ViewPanel extends Component {

    static propTypes = {
        classes: PropTypes.object.isRequired,
    };

    state = {};

    render() {
        const {classes} = this.props;

        return (
            <NGLContext.Consumer>
                {(contextNGL) => (
                    <React.Fragment>
                        <div className={classes.contentWrapper}
                             ref={contextNGL.viewRef}>
                            <SidePanel/>
                            <ToggleBar stage={contextNGL.stage}/>
                            <NGLSpeedDials stage={contextNGL.stage}/>
                        </div>
                    </React.Fragment>
                )}
            </NGLContext.Consumer>

        );
    }
}

export default ViewPanel;